import { ContainerModule, interfaces } from 'inversify'
import { DY_TYPES } from '@compliance/di/serviceIdentifiers'
import { CaseStore } from '@compliance/modules/CaseStore'

export const caseStoreModule = () =>
  new ContainerModule((bind: interfaces.Bind) => {
    bind<CaseStore>(DY_TYPES.CaseStore).to(CaseStore)
  })
